import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index";
import guard from "@/guard/routeGuard.js";
const { validationRoute } = guard;

Vue.use(VueRouter);

const routes = [
  // LOGIN
  {
    path: "/",
    component: () => import("@/views/ViewWithoutLayout.vue"),
    children: [
      {
        path: "",
        name: "Login",
        component: () => import("@/components/modules/login/Login.vue"),
      },
    ],
  },

  // DASHBOARD
  {
    path: "/acesso-rapido",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Acesso Rápido",
        permission: "dashboard",
        component: () => import("@/components/modules/dashboard/Dashboard.vue"),
      },
    ],
  },

  // CAD. BÁSICOS
  // PERFIS
  {
    path: "/perfis",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Perfis",
        permission: "list_profiles",
        component: () => import("@/components/modules/profiles/Grid.vue"),
      },
    ],
  },

  // USUARIOS
  {
    path: "/usuarios",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Usuários",
        permission: "list_users",
        component: () => import("@/components/modules/users/UserGrid.vue"),
      },
    ],
  },

  // MINHA CONTA
  {
    path: "/minha-conta",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Minha Conta",
        permission: "account",
        component: () => import("@/components/modules/my-account/Account.vue"),
      },
    ],
  },

  // RESETAR SENHA
  {
    path: "/esqueci-minha-senha",
    component: () => import("@/views/ViewWithoutLayout.vue"),
    children: [
      {
        path: "",
        name: "Esqueci minha senha",
        component: () => import("@/components/modules/password/Password.vue"),
      },
    ],
  },

  //Lista de vagas
  {
    path: "/lista-vagas",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Vagas",
        permission: "list_schedules",
        component: () =>
          import("@/components/modules/vacancy-list/VacancyList.vue"),
      },
    ],
  },
  {
    path: "/consulta-policlinicas",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Policlinicas",
        permission: "list_polyclinics",
        component: () => import("@/components/modules/policlinica/Grid.vue"),
      },
      {
        path: "cadastrar",
        name: "Cadastrar Policlinicas",
        permission: "reg_polyclinic",
        component: () => import("@/components/modules/policlinica/Unidade.vue"),
      },
      {
        path: "abrangencia",
        name: "Rede de abrangência",
        permission: "reg_polyclinic",
        component: () =>
          import("@/components/modules/policlinica/coverage/Coverages.vue"),
      },
    ],
  },

  {
    path: "/transporte",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Transportes",
        permission: "list_transports",
        component: () => import("@/components/modules/transport/Grid.vue"),
      },
    ],
  },

  {
    path: "/pacientes",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Pacientes",
        permission: "list_patients",
        component: () => import("@/components/modules/patients/Grid.vue"),
      },
      {
        path: "paciente",
        name: "Cadastrar Paciente",
        permission: "reg_patient",
        component: () => import("@/components/modules/patients/Patient.vue"),
      },
      {
        path: "paciente/:id",
        name: "Editar Paciente",
        permission: "edit_patient",
        component: () => import("@/components/modules/patients/Patient.vue"),
      },
    ],
  },
  {
    path: "/motorista",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Motorista",
        permission: "list_drivers",
        component: () => import("@/components/modules/drive/Grid.vue"),
      },
    ],
  },

  {
    path: "/rota",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Rotas",
        permission: "list_routes",
        component: () => import("@/components/modules/route/Grid.vue"),
      },

      {
        path: ":id",
        name: "Cadastrar Ponto de Parada ",
        permission: "reg_route",
        component: () => import("@/components/modules/route/Create.vue"),
      },
    ],
  },
  {
    path: "/macrorregiao",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Macrorregiões",
        permission: "list_macro_regions",
        component: () => import("@/components/modules/macrorregiao/Grid.vue"),
      },
    ],
  },

  //Municipios
  {
    path: "/municipios",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Municipios",
        permission: "list_counties",
        component: () => import("@/components/modules/county/Grid.vue"),
      },
    ],
  },

  //Viagem
  {
    path: "/viagem",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Viagem",
        permission: "list_trips",
        component: () => import("@/components/modules/trip/Grid.vue"),
      },
      {
        path: ":id",
        name: "Cadastrar Saídas",
        permission: "reg_trip",
        component: () => import("@/components/modules/trip/Create.vue"),
      },
    ],
  },

  //Região de Saúde
  {
    path: "/regiaodesaude",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Região de Saúde",
        permission: "list_health_regions",
        component: () => import("@/components/modules/health-region/Grid.vue"),
      },
    ],
  },

  // Agenda
  {
    path: "/agenda",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Agendamento",
        permission: "list_schedules",
        component: () => import("@/components/modules/agenda/Grid.vue"),
      },
      {
        path: "novo",
        name: "Novo Agendamento",
        permission: "reg_schedule",
        component: () => import("@/components/modules/agenda/Create.vue"),
      },
    ],
  },

  {
    path: "/profissional",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Profissionais",
        // alterar permission
        permission: "list_pact_exams",
        component: () => import("@/components/modules/professional/Grid.vue"),
      },
    ],
  },

  {
    path: "/ociosas",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Vagas Ociosas",
        permission: "list_schedules",
        component: () =>
          import("@/components/modules/idle_vacancies/Create.vue"),
      },
      {
        path: "adicionar/consulta",
        name: "Agendamento por Vagas Ociosas - Consultas",
        permission: "reg_patient",
        component: () =>
          import(
            "@/components/modules/idle_vacancies/components/schedule_consult.vue"
          ),
      },
      {
        path: "adicionar/exame",
        name: "Agendamento por Vagas Ociosas - Exames",
        permission: "reg_patient",
        component: () =>
          import(
            "@/components/modules/idle_vacancies/components/schedule_exam.vue"
          ),
      },
    ],
  },

  //Histórico de agendamento
  {
    path: "/historico-de-agenda",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Lista de agendamentos por Consulta",
        permission: "list_schedules",
        component: () => import("@/components/modules/historic/GridFilter.vue"),
      },
      {
        path: "exame",
        name: "Lista de agendamentos por Exame",
        permission: "list_schedules",
        component: () =>
          import("@/components/modules/historic_exam/GridFilter.vue"),
      },
    ],
  },

  //Pactuação
  {
    path: "/pactuacao",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Pactuação - Consultas",
        permission: "list_pactuations",
        component: () => import("@/components/modules/agreement/Grid.vue"),
      },
      {
        path: "criar",
        name: "Distribuição de Ofertas",
        permission: "reg_pactuation",
        component: () => import("@/components/modules/agreement/Consult.vue"),
      },
    ],
  },

  //Pactuação por Exame
  {
    path: "/exame",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Pactuação - Exames",
        permission: "list_pact_exams",
        component: () => import("@/components/modules/agreement-exam/Grid.vue"),
      },
      {
        path: "criar",
        name: "Distribuição de Ofertas de Exames",
        permission: "reg_pact_exam",
        component: () =>
          import("@/components/modules/agreement-exam/Consult.vue"),
      },
    ],
  },

  //Ceder Vagas
  {
    path: "/ceder-vagas",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Ceder Vagas - Consultas",
        permission: "exec_giveway",
        component: () => import("@/components/modules/vacancies/Grid.vue"),
      },
    ],
  },

  //Ceder Vagas - Exames
  {
    path: "/vagas/exames",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Ceder Vagas - Exames",
        permission: "list_schedules",
        component: () => import("@/components/modules/vacancies_exam/Grid.vue"),
      },
    ],
  },

  //Ceder Vagas - Exames
  {
    path: "/feriados",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Feriados, Recessos e Pontos Facultativos",
        permission: "list_schedules",
        component: () => import("@/components/modules/holiday/HolidayGrid.vue"),
      },
    ],
  },

  //Marcação de viagem
  {
    path: "/marcacao-viagem",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Marcação de Viagem",
        permission: "list_schedules",
        component: () => import("@/components/modules/travel/Grid.vue"),
      },
      {
        path: "incluir/:id",
        name: "Marcar Viagem",
        permission: "reg_schedule",
        component: () =>
          import("@/components/modules/travel/actions/Include.vue"),
      },
      {
        path: "externo/:id",
        name: "Marcação Externa",
        permission: "reg_schedule",
        component: () =>
          import("@/components/modules/travel/actions/External.vue"),
      },
    ],
  },

  // relatorios
  {
    path: "/relatorio",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "consulta",
        name: "Consultar Relatorio por Vagas - Consulta",
        permission: "list_report",
        component: () =>
          import(
            "@/components/modules/report/form/FormReportVacanciesConsult.vue"
          ),
      },
      {
        path: "exame",
        name: "Consultar Relatorio por Vagas - Exames",
        permission: "list_report",
        component: () =>
          import(
            "@/components/modules/report/form/FormReportVacanciesExams.vue"
          ),
      },
      {
        path: "saldo/consulta",
        name: "Consultar Relatorio por Saldo de Vagas - Consulta",
        permission: "list_report",
        component: () =>
          import("@/components/modules/report/form/FormReportSaleConsult.vue"),
      },
      {
        path: "saldo/exame",
        name: "Consultar Relatorio por Saldo de Vagas - Exames",
        permission: "list_report",
        component: () =>
          import("@/components/modules/report/form/FormReportSaleExam.vue"),
      },
      {
        path: "ociosas/exame",
        name: "Consultar Relatorio por Vagas Ociosas - Exames",
        permission: "list_report",
        component: () =>
          import("@/components/modules/report/form/FormReportIdleExam.vue"),
      },
      {
        path: "ociosas/consulta",
        name: "Consultar Relatorio por Vagas Ociosas - Consulta",
        permission: "list_report",
        component: () =>
          import("@/components/modules/report/form/FormReportIdleConsult.vue"),
      },
      {
        path: "cessao/consulta",
        name: "Consultar Relatório de Cessão de Vagas - Consulta",
        permission: "list_report",
        component: () =>
          import(
            "@/components/modules/report/form/FormReportCessionConsult.vue"
          ),
      },
      {
        path: "cessao/exame",
        name: "Consultar Relatório de Cessão de Vagas - Exames",
        permission: "list_report",
        component: () =>
          import("@/components/modules/report/form/FormReportCessionExam.vue"),
      },
      {
        path: "diario/consulta",
        name: "Consultar Relatório Diário de Produção - Consulta",
        permission: "list_report",
        component: () =>
          import("@/components/modules/report/form/FormReportDailyConsult.vue"),
      },
      {
        path: "diario/exame",
        name: "Consultar Relatório Diário de Produção - Exames",
        permission: "list_report",
        component: () =>
          import("@/components/modules/report/form/FormReportDailyExam.vue"),
      },
    ],
  },

  // administração
  {
    path: "/administracao",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "pacientes",
        name: "Informações para ADM",
        permission: "list_schedules", //precisa de uma nova permissão criada pelo back
        component: () => import("@/components/modules/administration/Grid.vue"),
      },
      {
        path: "auditoria",
        name: "Auditoria",
        permission: "list_schedules", //precisa de uma nova permissão criada pelo back
        component: () =>
          import("@/components/modules/administration/AuditGrid.vue"),
      },
    ],
  },

  //Chat - teste
  {
    path: "/chat",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Chat",
        permission: "list_schedules",
        component: () => import("@/components/modules/chat_test/chat.vue"),
      },
      {
        path: "/calendar",
        name: "calendar",
        permission: "list_schedules",
        component: () =>
          import("@/components/modules/chat_test/test_calendar.vue"),
      },
    ],
  },
];

store.state.localRoutes = routes;

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

export default router;
